import * as React from "react";
import { Project } from "src/redux/projects";
import { WithNamespaces, withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";

interface Props {
  projects: Project[];
}

type PropsWithNamespaces = Props & WithNamespaces;

const ArchivedProjectsList = (props: PropsWithNamespaces) => (
  <div className="container-fluid">
    <div className="row">
      {props.projects.map(p => (
        <div className="col-12 col-lg-4 pr-4 pb-5" key={p.id}>
          <Link
            className="text-decoration-none"
            to={{
              pathname: `/library/projects/${p.id}`
            }}
          >
            <div className="card card-project">
              <div className="card-header">
                <div className="card-header-img">
                  {!p.image && (
                    <img className="default" src="assets/presta-defaut.jpg" />
                  )}
                  {p.image && <img src={p.image} />}
                </div>
              </div>
              <div className="card-body">
                <div>
                  <p className="mb-2">
                    {p.name} {p.city !== "" && `(${p.city})`}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  {props.t("library.table.refarka")} {p.refArka}
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  </div>
);
export default withNamespaces()(ArchivedProjectsList);



// WEBPACK FOOTER //
// ./src/components/ArchivedProjectsList.tsx